import * as Yup from "yup";

import {
    phoneRegex,
    zipRegex,
    dateCantBeInFuture,
    minimumYearsOld,
    maxYearAgo,
} from "./validationFunctions";

const whichFieldsAreActive = (fields) => {
    const fieldsToValidate = {};

    if (fields.patientInfoFirstName.active) {
        fieldsToValidate.patientInfoFirstName = fields.patientInfoFirstName.validations.required.value && Yup.string()
            .max(
                fields.patientInfoFirstName.validations.maxLength.value,
                fields.patientInfoFirstName.validations.maxLength.message
            )
            .required(
                () =>
                    fields.patientInfoFirstName.validations.required.message
            )
    }

    if (fields.patientInfoLastName.active) {
        fieldsToValidate.patientInfoLastName = fields.patientInfoLastName.validations.required.value && Yup.string()
            .max(
                fields.patientInfoLastName.validations.maxLength.value,
                fields.patientInfoLastName.validations.maxLength.message
            )
            .required(
                () =>
                    fields.patientInfoLastName.validations.required.message
            )
    }

    if (fields.patientInfoDob.active) {

        fieldsToValidate.patientInfoDob = fields.patientInfoDob.validations.required.value && Yup.date()
            .required(
                () =>
                    fields.patientInfoDob.validations.required.message
            )

            .test(
                "patientInfoDob",
                fields.patientInfoDob.validations.maxYearsAgo.message,
                function (date) {
                    var todaysDate = new Date();
                    var enteredDate = new Date(date);
                    return enteredDate.getFullYear() >= 1900;
                }
            ).nullable()
            .test(
                "patientInfoDob",
                fields.patientInfoDob.validations.notFutureDate.message,
                function (date) {
                    var todaysDate = new Date();
                    var enteredDate = new Date(date);
                    return todaysDate > enteredDate;
                }
            )
    }


    if (fields.patientInfoMrn.active) {
        fieldsToValidate.patientInfoMrn = fields.patientInfoMrn.validations.required.value && Yup.string()
            .required(
                () =>
                    fields.patientInfoMrn.validations.required.message
            )
            .max(
                fields.patientInfoMrn.validations.maxLength.value,
                fields.patientInfoMrn.validations.maxLength.message
            )

    }


    if (fields.patientInfoEmail.active) {
        fieldsToValidate.patientInfoEmail = fields.patientInfoEmail.validations.required.value && Yup.string()
            .required(
                () =>
                    fields.patientInfoEmail.validations.required.message
            )
            .email(
                fields.patientInfoEmail.validations.validEmail.message
            )
            .test(
                "emailValidatation",
                fields.patientInfoEmail.validations.validEmail.message,
                function (email) {
                    return /^\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}$/.test(email)
                }
            )
    }
    if (fields.patientInfoEmailConfirmation.active) {
        fieldsToValidate.patientInfoEmailConfirmation = fields.patientInfoEmailConfirmation.validations.required.value && Yup.string()
            .required(
                () =>
                    fields.patientInfoEmailConfirmation.validations.required.message
            )
            .email(
                fields.patientInfoEmailConfirmation.validations.validEmail.message
            )
            .test(
                "emailValidatation",
                fields.patientInfoEmail.validations.validEmail.message,
                function (email) {
                    return /^\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}$/.test(email)
                }
            )
            .oneOf(
                [
                    Yup.ref(
                        fields.patientInfoEmailConfirmation.validations
                            .mustMatch.value
                    ),
                    null
                ],
                fields.patientInfoEmailConfirmation.validations.mustMatch
                    .message
            )
    }

    if (fields.patientInfoPhone.active) {
        fieldsToValidate.patientInfoPhone = fields.patientInfoPhone.validations.required.value && Yup.string()
            .required(
                () =>
                    fields.patientInfoPhone.validations.required.message
            )
            .max(
                fields.patientInfoPhone.validations.maxLength
                    .value,
                fields.patientInfoPhone.validations.maxLength
                    .message
            )
            .matches(
                phoneRegex,
                fields.patientInfoPhone.validations.validPhone.message
            )

    }

    if (fields.patientInfoPhoneConfirmation.active) {
        fieldsToValidate.patientInfoPhoneConfirmation = fields.patientInfoPhoneConfirmation.validations.required.value && Yup.string()
            .required(
                () =>
                    fields.patientInfoPhoneConfirmation.validations.required.message
            )
            .max(
                fields.patientInfoPhoneConfirmation.validations.maxLength.value,
                fields.patientInfoPhoneConfirmation.validations.maxLength.message
            )
            .matches(
                phoneRegex,
                fields.patientInfoPhoneConfirmation.validations.validPhone.message
            )
            .oneOf(
                [
                    Yup.ref(
                        fields.patientInfoPhoneConfirmation.validations
                            .mustMatch.value
                    ),
                    null
                ],
                fields.patientInfoPhoneConfirmation.validations.mustMatch
                    .message
            )

    }

    if (fields.patientInfoAddressLine1.active) {
        fieldsToValidate.patientInfoAddressLine1 = fields.patientInfoAddressLine1.validations.required.value && Yup.string()
            .required(
                () =>
                    fields.patientInfoAddressLine1.validations.required.message
            )
            .max(
                fields.patientInfoAddressLine1.validations.maxLength.value,
                fields.patientInfoAddressLine1.validations.maxLength.message
            )

    }

    if (fields.patientInfoAddressLine2.active) {
        fieldsToValidate.patientInfoAddressLine2 = fields.patientInfoAddressLine2.validations.required.value && Yup.string()
            .required(
                () =>
                    fields.patientInfoAddressLine2.validations.required.message
            )
            .max(
                fields.patientInfoAddressLine2.validations.maxLength.value,
                fields.patientInfoAddressLine2.validations.maxLength.message
            )
    }


    if (fields.patientInfoCity.active) {
        fieldsToValidate.patientInfoCity = fields.patientInfoCity.validations.required.value && Yup.string()
            .required(
                () =>
                    fields.patientInfoCity.validations.required.message
            )
            .max(
                fields.patientInfoCity.validations.maxLength.value,
                fields.patientInfoCity.validations.maxLength.message
            )

    }

    if (fields.patientInfoState.active) {
        fieldsToValidate.patientInfoState = fields.patientInfoState.validations.required.value && Yup.string()
            .required(
                () =>
                    fields.patientInfoState.validations.required.message
            )
            .max(
                fields.patientInfoState.validations.maxLength.value,
                fields.patientInfoState.validations.maxLength.message
            )

    }

    if (fields.patientInfoZip.active) {
        fieldsToValidate.patientInfoZip = fields.patientInfoZip.validations.required.value && Yup.string()
            .required(
                () =>
                    fields.patientInfoZip.validations.required.message
            )
            .max(
                fields.patientInfoZip.validations.maxLength.value,
                fields.patientInfoZip.validations.maxLength.message
            )
            .matches(
                zipRegex,
                fields.patientInfoZip.validations.validZipcode.message
            )

    }

    return fieldsToValidate;
}

export const patientInformationValidations = section => {
    if (section.active) {
        return Yup.object().shape(
            whichFieldsAreActive(section.fields)

        );
    } else {
        return Yup.object().shape();
    }
};
